import { MessageSquare, X } from 'lucide-react';
import { useUIStore } from '@/stores/uiStore';

export default function MobileToggle() {
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);

  // Show toggle whenever sidebar is closed (not just mobile)
  if (sidebarOpen) return null;

  return (
    <button
      onClick={toggleSidebar}
      className="fixed bottom-4 left-4 z-[1100] w-11 h-11 bg-accent-blue rounded-full shadow-xl flex items-center justify-center text-white hover:bg-accent-purple transition-colors"
      title="Abrir chat"
    >
      <MessageSquare size={18} />
    </button>
  );
}
